import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { PayrollItemEmployee } from './payroll-item-employee.model';

export const loadPayrollItemEmployees = createAction(
    '[PayrollItemEmployee/API] Load PayrollItemEmployees',
    props<{ payrollItemEmployees: PayrollItemEmployee[] }>()
);

export const addPayrollItemEmployee = createAction(
    '[PayrollItemEmployee/API] Add PayrollItemEmployee',
    props<{ payrollItemEmployee: PayrollItemEmployee }>()
);

export const upsertPayrollItemEmployee = createAction(
    '[PayrollItemEmployee/API] Upsert PayrollItemEmployee',
    props<{ payrollItemEmployee: PayrollItemEmployee }>()
);

export const addPayrollItemEmployees = createAction(
    '[PayrollItemEmployee/API] Add PayrollItemEmployees',
    props<{ payrollItemEmployees: PayrollItemEmployee[] }>()
);

export const upsertPayrollItemEmployees = createAction(
    '[PayrollItemEmployee/API] Upsert PayrollItemEmployees',
    props<{ payrollItemEmployees: PayrollItemEmployee[] }>()
);

export const updatePayrollItemEmployee = createAction(
    '[PayrollItemEmployee/API] Update PayrollItemEmployee',
    props<{ payrollItemEmployee: Update<PayrollItemEmployee> }>()
);

export const updatePayrollItemEmployees = createAction(
    '[PayrollItemEmployee/API] Update PayrollItemEmployees',
    props<{ payrollItemEmployees: Update<PayrollItemEmployee>[] }>()
);

export const deletePayrollItemEmployee = createAction(
    '[PayrollItemEmployee/API] Delete PayrollItemEmployee',
    props<{ id: string }>()
);

export const deletePayrollItemEmployees = createAction(
    '[PayrollItemEmployee/API] Delete PayrollItemEmployees',
    props<{ ids: string[] }>()
);

export const clearPayrollItemEmployees = createAction(
    '[PayrollItemEmployee/API] Clear PayrollItemEmployees'
);

export const getPayrollItemEmployees = createAction(
    '[PayrollItemEmployee/API] Get PayrollItemEmployees',
    props<{ PIListID: string }>()
);
